import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    maxHeight: 300,
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
    width: "100%",
    paddingBottom: 0,
  },
  cursorPointer: {
    cursor: "pointer",
  },
  cursorNotAllowed: {
    cursor: "not-allowed",
  },
  listHeader: {
    padding: "0px 16px",
    color: "black",
    borderBottom: "1px solid #e6e6e6",
  },
  listItem: {
    padding: "0px 32px",
    color: "#5a5a5a",
    borderBottom: "1px solid #f3f3f3",
  },
}));

export default function OrgAndGroupList(props) {
  const classes = useStyles();
  const { handleChange, items } = props;

  return (
    <List className={classes.root} subheader={<li />} disablePadding>
      {items?.map(({ org_id, org_name, can_switch_to_org, groups = [] }) => (
        <li key={`section-${org_id}`} className={classes.listSection}>
          <ul className={classes.ul}>
            <ListSubheader
              className={clsx(can_switch_to_org ? classes.cursorPointer : classes.cursorNotAllowed, classes.listHeader)}
              onClick={() => {
                if (can_switch_to_org) {
                  handleChange(org_id, groups[0]?.group_id, "org");
                }
              }}
            >
              {org_name}
            </ListSubheader>
            {groups?.map(({ group_id, group_name, user_type }) => (
              <ListItem
                key={`item-${org_id}-${group_id}`}
                className={clsx(classes.cursorPointer, classes.listItem)}
                onClick={() => {
                  handleChange(org_id, group_id, user_type);
                }}
              >
                <ListItemText primary={group_name} />
              </ListItem>
            ))}
          </ul>
        </li>
      ))}
    </List>
  );
}
